import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productslistStyle.js";
import Products from "views/Learning/Main/Sections/Products";
import { Button, Chip, Link } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';


const useStyles = makeStyles(styles);

export default function ProductsList() {
  const classes = useStyles();
  return (
    <>
      <Products show={"hide"} tags={['FirstPage']}></Products>
      <div class={classes.ShowAll}>
        <Button className={classes.ActionButton} href="/Courses" variant="outlined" startIcon={<ArrowForwardIosIcon />}>
          مشاهده همه دوره ها
        </Button>
      </div>
      <br/>
      <br/>
    </>
  );
}
